<template>

    <div class="flex items-center justify-between mb-8">

        <Head :title="$t('suppliers.suppliers')" />

        <page-title :title="$t('suppliers.suppliers')"></page-title>

        <div class="flex md:mt-0 md:ml-4">

            <switch-input :label="$t('suppliers.inactiveSuppliers')" v-model="form.withArchive"></switch-input>

            <primary-button type="button"
                            :disabled="blocked"
                            class="ml-3 inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium text-white bg-minplan-greybeige hover:bg-minplan-lightgreybeige focus:outline-none uppercase"
                            @click="toCreatePage()">
                <PlusSmIcon class="-ml-1 md:mr-2 h-5 w-5 text-white md:text-minplan-darkgreybeige" />
                <span class="hidden md:inline font-bold">{{ $t("suppliers.newSupplier") }}</span>
            </primary-button>
        </div>
    </div>

    <div class="flex-1 flex justify-center">
        <div class="w-full">
            <label for="search" class="sr-only">Search</label>
            <div class="relative text-gray-400 focus-within:text-gray-600">
                <div class="pointer-events-none absolute inset-y-0 left-0 pl-3 flex items-center">
                    <SearchIcon class="h-5 w-5" aria-hidden="true" />
                </div>
                <input id="search"
                       class="block w-full py-2 pl-10 pr-3 border border-minplan-beige rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-minplan-beige focus:ring-white focus:border-white sm:text-sm"
                       placeholder="Suche..."
                       autocomplete="off"
                       type="search"
                       name="search"
                       v-model="form.search" />
            </div>
        </div>
    </div>

    <ul role="list" class="mt-6">
        <li v-for="supplier in suppliers.data" :key="supplier.uuid">
            <supplier-card :supplier="supplier"></supplier-card>
        </li>
    </ul>

    <!-- Pagination -->
    <pagination :links="suppliers.links"></pagination>
</template>

<script>
import { defineComponent, ref } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import SettingsLayout from "@/Layouts/SettingsLayout";
import { mapValues, pickBy, throttle } from "lodash";
import { PlusSmIcon, SearchIcon } from "@heroicons/vue/outline";
import Pagination from "@/Shared/Components/Pagination";
import PageTitle from "@/Shared/Components/PageTitle";
import SupplierCard from "@/Pages/Suppliers/Components/SupplierCard";
import SwitchInput from "@/Shared/Components/SwitchInput";
import PrimaryButton from "@/Jetstream/PrimaryButton.vue";
import { Head } from "@inertiajs/inertia-vue3";

export default defineComponent({
    props: {
        filter: Object,
        suppliers: Object,
        blocked: Boolean
    },
    layout: [MainLayout, SettingsLayout],
    components: {
        Head,
        PrimaryButton,
        PlusSmIcon,
        SearchIcon,
        Pagination,
        PageTitle,
        SupplierCard,
        SwitchInput
    },
    setup() {
        const enabled = ref(false);
        const enabledActive = ref(false);

        return {
            enabled,
            enabledActive
        };
    },
    data() {
        return {
            form: {
                search: this.filter.search,
                withInactive: this.filter.withInactive
            }
        };
    },
    watch: {
        form: {
            deep: true,
            handler: throttle(function() {
                let query = {
                    "filter[search]": this.form.search,
                    "filter[withInactive]": this.form.withInactive
                };

                this.$inertia.get(this.route("suppliers.index"), pickBy(query), {
                    preserveState: true
                });
            }, 150)
        }
    },
    methods: {
        toCreatePage() {
            this.$inertia.get(this.route("advisors.suppliers.create"));
        },
        reset() {
            this.form = mapValues(this.form, () => null);
        }
    }
});
</script>

<style scoped></style>
